// Generated by Melange

import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function DocsPosts(Props) {
  return JsxRuntime.jsxs(React.Fragment, {
    children: [
      JsxRuntime.jsx("h3", {
        children: "Документация",
        className: "h4 lg:h3 text-black-landing mt-10 lg:mt-16"
      }),
      JsxRuntime.jsx("p", {
        children: "Исследуйте наши руководства и примеры интеграции с Бухта.",
        className: "paragraph text-black-landing mt-2 lg:mt-1"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("h4", {
                children: "Касса",
                className: "h5 lg:h4 mt-6 lg:mt-0 text-black-landing"
              }),
              JsxRuntime.jsx("p", {
                children: "Технологичная фискализация без ошибок",
                className: "paragraph text-black-landing mt-1"
              }),
              JsxRuntime.jsxs("button", {
                children: [
                  JsxRuntime.jsx("img", {
                    src: StaticAsset.src("/static/icons/forward.svg")
                  }),
                  JsxRuntime.jsx("p", {
                    children: "Начать знакомство",
                    className: "paragraph-small-medium text-white ml-1"
                  })
                ],
                className: "flex bg-primary-variant items-center my-6 lg:mt-8 lg:mb-0 px-3 py-2 rounded"
              })
            ]
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("img", {
              className: "w-56 lg:w-64 ml-7",
              alt: "kassa mobile",
              src: StaticAsset.src("/static/images/kassa-mobile.png")
            }),
            className: "overflow-hidden h-48"
          })
        ],
        className: "bg-bg rounded-sm pt-6 lg:pt-8 pl-6 lg:pl-8 lg:pr-16 mt-10 flex lg:h-63 justify-between flex-col-reverse lg:flex-row"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("div", {
                className: "h-40 bg-bg rounded"
              }),
              JsxRuntime.jsx("h6", {
                children: "Склад и закупки",
                className: "h6 text-primary-variant mt-2"
              }),
              JsxRuntime.jsx("p", {
                children: "Ведение учета запасов, перемещений",
                className: "paragraph text-gray-landing"
              })
            ],
            className: "w-full lg:w-105.5"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("div", {
                className: "h-40 bg-bg rounded"
              }),
              JsxRuntime.jsx("h6", {
                children: "Налоговая отчетность",
                className: "h6 text-primary-variant mt-2"
              }),
              JsxRuntime.jsx("p", {
                children: "Автоматическая сдача налоговой отчетности",
                className: "paragraph text-gray-landing"
              })
            ],
            className: "w-full lg:w-105.5 mt-6 lg:mt-0"
          })
        ],
        className: "flex justify-between mt-10 flex-wrap"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "shrink-0",
                src: StaticAsset.src("/static/icons/avatar-integration.svg")
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("p", {
                    children: "Интеграция с банками",
                    className: "paragraph-medium text-primary-variant"
                  }),
                  JsxRuntime.jsx("p", {
                    children: "Банк в бухгалтерии, документы на основании платежек и наоборот",
                    className: "paragraph-small text-gray-landing"
                  })
                ],
                className: "ml-4"
              })
            ],
            className: "lg:w-105.5 flex items-center mt-6"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "shrink-0",
                src: StaticAsset.src("/static/icons/doc-flow.svg")
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("p", {
                    children: "Документооборот",
                    className: "paragraph-medium text-primary-variant"
                  }),
                  JsxRuntime.jsx("p", {
                    children: "Все документы подписываются в электронном виде",
                    className: "paragraph-small text-gray-landing"
                  })
                ],
                className: "ml-4"
              })
            ],
            className: "lg:w-105.5 flex items-center mt-6"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "shrink-0",
                src: StaticAsset.src("/static/icons/salary.svg")
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("p", {
                    children: "Зарплата и кадры",
                    className: "paragraph-medium text-primary-variant"
                  }),
                  JsxRuntime.jsx("p", {
                    children: "Начисление зарплаты на основании посещаемости",
                    className: "paragraph-small text-gray-landing"
                  })
                ],
                className: "ml-4"
              })
            ],
            className: "lg:w-105.5 flex items-center mt-6"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "shrink-0",
                src: StaticAsset.src("/static/icons/esf.svg")
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("p", {
                    children: "ЭСФ",
                    className: "paragraph-medium text-primary-variant"
                  }),
                  JsxRuntime.jsx("p", {
                    children: "Акты, накладные. ЭСФ, ЭАВР, СНТ",
                    className: "paragraph-small text-gray-landing"
                  })
                ],
                className: "ml-4"
              })
            ],
            className: "lg:w-105.5 flex items-center mt-6"
          })
        ],
        className: "flex flex-wrap justify-between lg:mt-4"
      }),
      JsxRuntime.jsx("hr", {
        className: "text-divider mt-10"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "shrink-0",
                src: StaticAsset.src("/static/icons/tis.svg")
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("p", {
                    children: "ТИС",
                    className: "paragraph-medium text-primary-variant"
                  }),
                  JsxRuntime.jsx("p", {
                    children: "Система возволяющая вести все от поступления до продаж",
                    className: "paragraph-small text-gray-landing"
                  })
                ],
                className: "ml-4"
              })
            ],
            className: "lg:w-105.5 flex items-center mt-6"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "shrink-0",
                src: StaticAsset.src("/static/icons/api.svg")
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("p", {
                    children: "API",
                    className: "paragraph-medium text-primary-variant"
                  }),
                  JsxRuntime.jsx("p", {
                    children: "Получи сервисы Бухты по API",
                    className: "paragraph-small text-gray-landing"
                  })
                ],
                className: "ml-4"
              })
            ],
            className: "lg:w-105.5 flex items-center mt-6"
          })
        ],
        className: "flex flex-wrap justify-between mt-4"
      }),
      JsxRuntime.jsx("hr", {
        className: "text-divider mt-10"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "shrink-0",
                src: StaticAsset.src("/static/icons/product-account.svg")
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("p", {
                    children: "Товароучетная система",
                    className: "paragraph-medium text-primary-variant"
                  }),
                  JsxRuntime.jsx("p", {
                    children: "Система учета товаров, перемещения и остатков",
                    className: "paragraph-small text-gray-landing"
                  })
                ],
                className: "ml-4"
              })
            ],
            className: "lg:w-105.5 flex items-center mt-6"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "shrink-0",
                src: StaticAsset.src("/static/icons/large-business.svg")
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("p", {
                    children: "Крупному бизнесу",
                    className: "paragraph-medium text-primary-variant"
                  }),
                  JsxRuntime.jsx("p", {
                    children: "Индивидуальные технологические решения",
                    className: "paragraph-small text-gray-landing"
                  })
                ],
                className: "ml-4"
              })
            ],
            className: "lg:w-105.5 flex items-center mt-6"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "shrink-0",
                src: StaticAsset.src("/static/icons/restaurant.svg")
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("p", {
                    children: "Для ресторанов",
                    className: "paragraph-medium text-primary-variant"
                  }),
                  JsxRuntime.jsx("p", {
                    children: "Автоматизируйте работу своего ресторана полностью",
                    className: "paragraph-small text-gray-landing"
                  })
                ],
                className: "ml-4"
              })
            ],
            className: "lg:w-105.5 flex items-center mt-6"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "shrink-0",
                src: StaticAsset.src("/static/icons/retail.svg")
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("p", {
                    children: "Для розничной торговли",
                    className: "paragraph-medium text-primary-variant"
                  }),
                  JsxRuntime.jsx("p", {
                    children: "Полный контроль над торговой точкой",
                    className: "paragraph-small text-gray-landing"
                  })
                ],
                className: "ml-4"
              })
            ],
            className: "lg:w-105.5 flex items-center mt-6"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "shrink-0",
                src: StaticAsset.src("/static/icons/wholesale.svg")
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("p", {
                    children: "Для оптовой торговли",
                    className: "paragraph-medium text-primary-variant"
                  }),
                  JsxRuntime.jsx("p", {
                    children: "Контролируйте отгрузки и склады",
                    className: "paragraph-small text-gray-landing"
                  })
                ],
                className: "ml-4"
              })
            ],
            className: "lg:w-105.5 flex items-center mt-6"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "shrink-0",
                src: StaticAsset.src("/static/icons/online-store.svg")
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("p", {
                    children: "Для онлайн-магазинов",
                    className: "paragraph-medium text-primary-variant"
                  }),
                  JsxRuntime.jsx("p", {
                    children: "Бухгалтерия прямо у вас на сайте",
                    className: "paragraph-small text-gray-landing"
                  })
                ],
                className: "ml-4"
              })
            ],
            className: "lg:w-105.5 flex items-center mt-6"
          })
        ],
        className: "flex flex-wrap justify-between mt-4"
      })
    ]
  });
}

const make = DocsPosts;

export {
  make,
}
/* react Not a pure module */
